module.exports = __webpack_public_path__ + "static/img/new_block.943a77e8.png";